import React from 'react';
import ReactDOM from 'react-dom/client';
import { config, dom } from '@fortawesome/fontawesome-svg-core';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

config.autoAddCss = false;

const LAYER_NAME = 'chat';

export type MountOptions = {
	styleElement?: React.ReactNode;
};

export const mount = (element: HTMLElement, options: MountOptions = {}) => {
	const { styleElement } = options;
	const container = element;

	const myCache = createCache({
		key: LAYER_NAME,
		container,
	});

	const sheet = myCache.sheet;
	const originalInsert = sheet.insert.bind(sheet);
	sheet.insert = (rule: string) => {
		originalInsert(`@layer ${LAYER_NAME}{${rule}}`);
	};

	const root = ReactDOM.createRoot(element);
	const render = (
		app: React.ReactNode,
		dynamicStyleElement?: React.ReactNode,
	) => {
		root.render(
			<CacheProvider value={myCache}>
				<style id="fa-styles">{`@layer chat{${dom.css()}}`}</style>
				{dynamicStyleElement ?? styleElement}
				{app}
			</CacheProvider>,
		);
	};
	return {
		render,
		unmount: root.unmount,
	};
};
